import type { CitationData } from "@/lib/chat-types";

export function CitationBlock({ citation, compact = false }: { citation: CitationData; compact?: boolean }) {
  return (
    <div className={`overflow-hidden rounded-[12px] border border-[var(--color-border)] bg-[var(--color-surface)] ${compact ? "" : "my-2.5"}`}>
      <div className={compact ? "px-4 py-4 border-l-[3px] border-l-[var(--color-accent)] bg-[var(--color-surface)]/70" : "px-3.5 py-3"}>
        <div className="mb-2.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[10px] uppercase tracking-[0.14em] text-[var(--color-accent)]" style={{ fontFamily: "var(--font-mono)" }}>
          <span className="font-semibold">{citation.sourceTitle ?? "Regulatory Citation"}</span>
          {citation.page !== undefined && <span className="text-[var(--color-fg-tertiary)]">Page {citation.page}</span>}
        </div>
        <p className={`text-[var(--color-fg)] italic ${compact ? "text-[13px] leading-7" : "text-[14px] leading-7"}`}>&ldquo;{citation.text}&rdquo;</p>
        {!compact && (
          <div className="mt-2 flex flex-wrap items-center gap-2 text-[10px]" style={{ fontFamily: "var(--font-mono)" }}>
            <span className="font-semibold text-[var(--color-accent)]">{citation.source}</span>
            {citation.page !== undefined && (
              <span className="rounded-full border border-[var(--color-border)] px-2 py-0.5 text-[var(--color-fg-tertiary)]">
                p. {citation.page}
              </span>
            )}
            {citation.citationId && (
              <span className="rounded-full border border-[var(--color-border)] px-2 py-0.5 text-[var(--color-fg-tertiary)]">
                {citation.citationId}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
